import { GradingInformation } from "./types";

export const questionInformation: GradingInformation = {
  questions: [
    { gradingHelps: [], questionID: "4", question: "Device powers up?" },
    {
      gradingHelps: [
        {
          points: [
            "has one or more cracks on the front glass or the LCD is fractured",
            "has a shattered front glass",
            "is not functioning properly or responsive to touch",
            "has deep scratches that impair use or readability",
            "shows signs of bleeding, streaks or 'screen lifting'",
            "has a click or squish when applying pressure on a flat surface",
          ],
          heading: "Your device is not in good condition if the display:",
        },
        {
          points: [
            "signs of severe physical or liquid damage",
            "counterfeit or third party parts",
            "unauthorised modifications",
          ],
          heading: "We do not accept devices with:",
        },
      ],
      questionID: "5",
      question: "LCD works OK?",
    },
    {
      gradingHelps: [
        {
          points: [
            "has no scratches, minor scratches or general wear and tear scuffs",
            "has no dents or minor dents",
            "has no bend or a minor bend",
            "camera lens is not missing, cracked, or damaged (phone and tablet only)",
            "has sensors clear of any scratches or condensation (watch only)",
          ],
          heading: "Select ‘Yes’ if your device:",
        },
        {
          points: [
            "has significant signs of damage beyond general wear and tear",
            "has a large bend",
            "has the case missing",
            "has a swollen battery",
            "camera lens is missing, cracked, or damaged (phone and tablet only)",
            "has sensors covered by scratches or condensation (watch only)",
          ],
          heading: "Select ‘No’ if your device:",
        },
        {
          points: [
            "signs of severe physical or liquid damage",
            "counterfeit or third party parts",
            "unauthorized modifications",
          ],
          heading: "We do not accept devices with:",
        },
      ],
      questionID: "8",
      question: "Casing - no major defects?",
    },
    {
      gradingHelps: [
        {
          points: ["has all of the buttons present"],
          heading: "Select “Yes” if your device:",
        },
        {
          points: ["Sleep/Wake, Volume, Home, Ring/Silent switch"],
          heading: "Phone or tablet",
        },
        {
          points: [
            "Crown, Side, band release",
            "All of the buttons are functioning properly",
            "The band can attach and detach from the enclosure with no issues",
          ],
          heading: "Watch",
        },
        {
          points: ["has one or more of the buttons missing"],
          heading: "Select “No” if your device:",
        },
        {
          points: ["Sleep/Wake, Volume, Home, Ring/Silent switch"],
          heading: "Phone or tablet",
        },
        {
          points: [
            "Crown, Side, band release",
            "One or more of the buttons are not functioning properly",
            "The band has issues attaching or detaching to the case",
          ],
          heading: "Watch",
        },
        {
          points: [
            "counterfeit or third party parts",
            "unauthorized modifications",
          ],
          heading: "We do not accept devices with:",
        },
      ],
      questionID: "9",
      question: "Buttons working?",
    },
    {
      gradingHelps: [
        {
          heading: "Select ‘Yes’ if your device:",
          points: [
            "has all of the buttons are present (Sleep/Wake, Volume, Home, Ring/Silent switch)",
            "has all of the buttons functioning properly",
            "trackpad is responsive and is fully working",
          ],
        },
        {
          heading: "Select ‘No’ if your device:",
          points: [
            "has one or more of the buttons missing (Sleep/Wake, Volume, Home, Ring/Silent switch)",
            "has one or more of the buttons not functioning properly",
            "trackpad is unresponsive and not fully working",
          ],
        },
        {
          heading: "We do not accept devices with:",
          points: [
            "counterfeit or third party parts",
            "unauthorized modifications",
          ],
        },
      ],
      questionID: "119",
      question: "Are the buttons, keys or trackpad in good working condition?",
    },
    {
      gradingHelps: [],
      questionID: "120",
      question: "Is the Power Adapter present?",
    },
  ],
};
